import { Skeleton, Typography as MuiTypography, Stack } from '@mui/material';
import { TypographyProps } from './types';

export const Typography = ({ isLoading, StartIcon, ...props }: TypographyProps) => {
    const text = isLoading ? <Skeleton variant="text" sx={{ minWidth: 100, maxWidth: 200, flex: 1, width: 1 }} /> : props.children;

    const content = StartIcon ? (
        <Stack direction="row" spacing={0.5} alignItems="center">
            <StartIcon size="small" />
            <span style={{ flex: 1 }}>{text}</span>
        </Stack>
    ) : (
        text
    );

    return <MuiTypography {...props}>{content}</MuiTypography>;
};
